import { motion } from "framer-motion";
import { ClipboardList, ShieldCheck, Truck } from "lucide-react";

const steps = [
  { icon: ClipboardList, title: "Tell us what you need", desc: "Book online or message us on WhatsApp with what's being delivered, moved or collected, and when." },
  { icon: ShieldCheck, title: "We send a van & crew", desc: "A fully-equipped van and trained two-man crew are matched to your job — no subcontractors, no surprises." },
  { icon: Truck, title: "Delivered, assembled, done", desc: "Careful handling into any room, assembly if needed, and all packaging cleared away." },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-20 sm:py-24 bg-white">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-blue-600 mb-4">How it works</p>
      <h2 className="text-4xl sm:text-5xl tracking-tight font-semibold text-slate-900">From booking to job done</h2>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-10" data-testid="how-it-works-steps">
        {steps.map((s, i) => (
          <motion.div key={s.title} data-testid={`step-${i + 1}`}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="relative">
            <div className="flex items-center gap-4">
              <span className="w-11 h-11 shrink-0 rounded-full bg-slate-900 text-white flex items-center justify-center font-bold">{i + 1}</span>
              <div className="h-px flex-1 bg-slate-200 hidden md:block" />
            </div>
            <div className="mt-6 flex items-center gap-3">
              <s.icon size={20} className="text-blue-600" />
              <h3 className="text-xl font-medium text-slate-900">{s.title}</h3>
            </div>
            <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
